import { useContext, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { MixpanelContext } from '../../../contexts/MixpanelContext';
import useLanguage from '../../../hooks/useLanguage';
import { __ } from '../../../translations';
import { EVENT } from '../constants/mixpanel';
import { BannerContent, BannerProps } from '../types/iBanner';

const useBannerActions = (carousel: BannerProps['carousel']) => {
    const language = useLanguage();
    const { track } = useContext(MixpanelContext);

    const bannerContent: BannerContent = useMemo(() => carousel?.data?.content?.[0] ?? {}, [carousel]);

    const {
        imageUrls = [],
        menuItemId = '',
        description = '',
        cta = '',
        title_p1 = '',
        title_p2 = '',
        badgeUrl = '',
    } = bannerContent;

    const ctaProps = useMemo(
        () => ({
            linkComponent: Link,
            text: __(cta),
            href: `/${language}/${menuItemId}`,
            transformLinkProps: (props: any) => ({ to: props?.href }),
        }),
        [cta, menuItemId, language]
    );

    const onCtaClick = () => {
        track(EVENT.GAMIFICATION.GAMIFICATION_CARD_CLICKED, {
            'Screen Name': 'Home screen',
        });
        track(EVENT.GAMIFICATION.REWARDS_DASHBORAD_VIEWED, {
            'Screen Name': 'Home card',
        });
    };

    return {
        title_p1: __(title_p1),
        title_p2: __(title_p2),
        ctaProps,
        onCtaClick,
        description: __(description),
        image: imageUrls?.[0]?.urlWeb ?? '',
        badgeUrl,
    };
};

export default useBannerActions;
